module.exports = "pegasus/assets/email1-img12.png";